<template>
  <div class="overlay">
    <div class="white-card">
      <div class="flex justify-center">
        <div class="spinner mt-8"></div>
      </div>
      <p class="mt-8 text-center font-bold text-xl">
        {{ message }}
      </p>
      <p class="mt-8 text-center font-semibold mb-8">
        {{ description }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TransmissionProposalLoading',
  data() {
    return {
      messages: [
        {
          title: 'VERIFICANDO TODOS OS DADOS',
          description: 'Isso pode levar até 2 minutos',
        },
        {
          title: 'TRANSMITINDO A PROPOSTA',
          description: 'Não feche esta janela',
        },
        {
          title: 'QUASE LÁ',
          description: 'Aguarde só mais uns instantes',
        },
      ],
      messageIndex: 0,
    };
  },
  computed: {
    message() {
      return this.messages[this.messageIndex].title;
    },
    description() {
      return this.messages[this.messageIndex].description;
    },
  },
  mounted() {
    this.callChangeMessageEveryFiveSeconds();
  },
  methods: {
    callChangeMessageEveryFiveSeconds() {
      setInterval(async () => {
        this.changeMessage();
      }, 5000);
    },
    changeMessage() {
      this.messageIndex = (this.messageIndex + 1) % this.messages.length;
    },
  },
};
</script>
<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #2b50bb;
  border-top: 5px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.white-card {
  padding: 20px;
  width: 350px;
  height: 250px;
  background-color: rgba(255, 255, 255);
  border-radius: 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
</style>
